import * as React from 'react';
import { CssBaseline } from '@material-ui/core';
import { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'fp-ts/lib/function';
import { withStyles } from '@material-ui/core/styles';
import { withLocalState, ILocalStateMgr } from './LocalState';
import { Routes } from './Routes';
import { DownloadUploadFiles } from './Components/DownloadUploadFiles';
import { SwitchBrowserMessage } from './SwitchBrowser';
import { ValidateEmailMessage } from './ValidateEmail';
import { ValidatePhoneMessage } from './ValidatePhone';
import services from '../Api/services';
import BackgroundImage from '../Assets/keyframe_logo.png';
import BackgroundImageOnlyHome from '../Assets/keyframe_logo_new.png';
import { browserName } from 'react-device-detect';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo-hooks';
import { Logout } from './Logout';

const GET_VIDEOS = ([field, direction]: ['created_at', 'desc']) => gql`
query MyVideos ($limit: Int, $offset: Int, $email: String!) {
    video (limit: $limit, offset: $offset, where: {user_creator_email: {_eq: $email}}, order_by: {${field}: ${direction}}) {
        created_at
        subtitle
        duration
        id
        s3_key
        title
    }
}
`;

interface IProps {
    classes: any;
    localStateMgr: ILocalStateMgr;
    location: any;
    history: any;
}

const drawerWidth = 240;

const styles = (theme: any) => ({
    root: {
        display: 'flex',
        flexDirection: 'column' as 'column',
        height: '100vh',
        backgroundColor: '#282833',
    },
    grow: {
        flexGrow: 1,
    },
    header: {
        backgroundColor: '#2d313b',
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
    gridItem: {
        width: '100%',
    },
    gridContainer: {
        padding: '0 20px',
    },
    content: {
        marginLeft: 0,
        display: 'flex',
        height: '100vh',
        transition: 'margin-left 0.5s ease-out',
        '&.maxWidth': {
            marginLeft: '72px',
        },
        '&.home-page::after': {
            content: '""',
            background: `url(${BackgroundImageOnlyHome}) no-repeat`,
            backgroundSize: '100vw 100vh',
            opacity: 1,
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
        },
        '&.other-pages::after': {
            content: '""',
            background: `url(${BackgroundImage}) no-repeat`,
            backgroundSize: '100vw 100vh',
            opacity: 0.007,
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
        },
    },
    inactive: {
        color: 'grey' as 'grey',
    },
    closeIcon: {
        '&:hover': {
            cursor: 'pointer',
            color: '#3f7fb5ab',
        },
    },
});

const Main = (props: IProps) => {
    const {
        classes,
        localStateMgr: { state, dispatch },
    } = props;
    const { location } = props;
    const username = localStorage.getItem('username');
    const password = localStorage.getItem('password');
    const isSuported = browserName.indexOf('Chrome') !== -1 ? false : true;
    const { data: videoIds, loading, error } = useQuery(
        GET_VIDEOS(['created_at', 'desc']),
        {
            variables: {
                email: username,
            },
        }
    );
    const [subscriptionVerification, setSubscriptionVerification] = useState(
        true
    );
    const [dialogState, setDialogState] = useState(isSuported);

    const [emailVerified, setEmailVerified] = useState(true);
    const [phoneVerified, setPhoneVerified] = useState(true);
    const [phone, setPhone]: any = useState();

    const [licenseVerification, setLicenseVerification] = useState(true);

    useEffect(() => {
        if (!loading) {
            if (!error) {
                const mappedData: [string, string] = videoIds.video.map(
                    ({ id }: { id: string }) => {
                        return id.split('/').map(encodeURIComponent).join('/');
                    }
                );
                dispatch({ type: 'ON_VIDEOS_LOADED', payload: mappedData });
            } else {
                console.error('fetching videos error', error);
            }
        }
    }, [loading]);

    const isHomeRoute = props.location.pathname === '/video-library';

    console.log('emailVerified', emailVerified);

    useEffect(() => {
        setSubscriptionVerification(true);

        setInterval(() => {
            services
                .login({
                    username,
                    password,
                })
                .then(({ data }: any) => {
                    // localStorage.setItem('uploadedBytes', data['uploaded-bytes']);

                    const registerDate = new Date(
                        data.account['user-management.user/created-at']
                    ).getTime();

                    const now = Date.now();
                    const diff = now - registerDate;

                    const trialOver = diff > 1000 * 60 * 60 * 24 * 14;

                    setLicenseVerification(data.stripe);
                    if (data.stripe || !trialOver) {
                        setSubscriptionVerification(true);
                        localStorage.setItem('subscription', 'true');
                    } else {
                        setSubscriptionVerification(false);
                        localStorage.setItem('subscription', 'false');
                    }
                })
                .catch(({ ex }: any) => {
                    // Logout();
                });
        }, 60000);
        services
            .login({
                username,
                password,
            })
            .then(({ data }: any) => {
                if (data.subscriptions.length === 0) {
                    localStorage.setItem('subscription', 'false');
                } else {
                    localStorage.setItem('subscription', 'true');
                }
                localStorage.setItem('userId', data['user-id']);
                localStorage.setItem(
                    'stored',
                    'You have used ' +
                        Math.ceil(
                            data['uploaded-bytes'] / Math.pow(1024, 3)
                        ).toString() +
                        'GB of your allocated 10GB storage.'
                );
                localStorage.setItem(
                    'quota',
                    (
                        (data['uploaded-bytes'] / Math.pow(1024, 3) / 10) *
                        100
                    ).toString()
                );
                const registerDate = new Date(
                    data.account['user-management.user/created-at']
                ).getTime();
                const _emailVerified = data['email-verified'];
                const _phoneVerified = data['phone-verified'];
                setPhone(data.phone);
                const now = Date.now();
                const diff = now - registerDate;
                // if user trial is ended and user doesn't have subscribe or affiliate - redirect to payment page
                if (!_emailVerified) {
                    console.log('email unverified');
                    setEmailVerified(false);
                }
                if (!_phoneVerified) {
                    console.log('phone unverified');
                    setPhoneVerified(false);
                }

                let trialOver = false;
                if (diff > 1000 * 60 * 60 * 24 * 14) {
                    trialOver = true;
                    // 7 days in ms
                    if (data.subscriptions.length === 0 && !data.affiliate) {
                        setSubscriptionVerification(false);
                    }
                }

                setLicenseVerification(data.stripe);
                if (data.stripe || !trialOver) {
                    setSubscriptionVerification(true);
                    localStorage.setItem('subscription', 'true');
                } else {
                    setSubscriptionVerification(false);
                    localStorage.setItem('subscription', 'false');
                }
            })
            .catch(({ ex }: any) => {
                Logout();
            });
    }, []);

    useEffect(() => {
        if (
            'ontouchstart' in window ||
            navigator.maxTouchPoints > 0 ||
            navigator.msMaxTouchPoints > 0
        ) {
            dispatch({ type: 'ON_TOUCH_DEVICE_DETECTED' });
        }
    }, []);

    return (
        <div className={classes.root}>
            {parseInt(localStorage.getItem('quota') ?? '0', 10) > 90 && (
                <div
                    title={localStorage.getItem('stored') ?? ''}
                    style={{
                        borderBottom: '13px solid red',
                        position: 'sticky',
                        zIndex: 10000,
                        maxWidth: '100%',
                        width: localStorage.getItem('quota') + '%',
                    }}
                />
            )}
            {parseInt(localStorage.getItem('quota') ?? '0', 10) > 80 &&
                parseInt(localStorage.getItem('quota') ?? '0', 10) < 90 && (
                    <div
                        title={localStorage.getItem('stored') ?? ''}
                        style={{
                            borderBottom: '13px solid orange',
                            position: 'sticky',
                            zIndex: 10000,
                            maxWidth: '100%',
                            width: localStorage.getItem('quota') + '%',
                        }}
                    />
                )}
            <CssBaseline />
            <main
                className={`${classes.content} ${
                    location.pathname === '/video-library'
                        ? 'home-page'
                        : 'other-pages'
                }`}
            >
                <Routes
                    isUserSubscribed={subscriptionVerification}
                    hasLicense={licenseVerification}
                />
            </main>
            <DownloadUploadFiles homeRoute={isHomeRoute} />
            <SwitchBrowserMessage
                open={dialogState}
                onClose={() => setDialogState(false)}
            />
            <ValidateEmailMessage emailUnverified={!emailVerified} />
        </div>
    );
};

const MainComponent = compose(
    withStyles(styles),
    withLocalState,
    withRouter
)(Main);

export default MainComponent;
